const getCountryName = (lat, lng) => {
  return new Promise((resolve, reject) => {
    fetch(
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.address && data.address.country) {
          resolve(data.address.country)
        } else {
          reject('No address found')
        }
      })
      .catch((error) => reject(error))
  })
}

export default getCountryName
